<template>
  <DealSticker
    class="my-8 w-full sm:mb-16 md:mt-0 md:w-auto"
    :class="{ 'mt-12': hasTelcoCalculator }"
    :icon
    @click="openModal(MODAL_NAMES.DEALS_MODAL)"
  >
    <template #title>
      {{ i18n(translations.title) }}
    </template>
    <template #description>
      {{ i18n(translations.description) }}
      <IconChevronRight class="ml-4 shrink-0" size="small" />
    </template>
  </DealSticker>
</template>

<script lang="ts" setup>
import { type Component, computed } from 'vue'

import { MarketCountryCode } from '@backmarket/http-api/src/api-models/MarketCountryCode'
import DealSticker from '@backmarket/nuxt-layer-recommendation/DealSticker.vue'
import { useExperiments } from '@backmarket/nuxt-module-experiments/useExperiments'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { useMarketplace } from '@backmarket/nuxt-module-marketplace/useMarketplace'
import { openModal } from '@ds/components/ModalBase'
import { IconChevronRight } from '@ds/icons/IconChevronRight'
import { IconPriceTagFilled } from '@ds/icons/IconPriceTagFilled'

import { MODAL_NAMES } from './DealSticker.constants'
import translations from './DealSticker.translations'

withDefaults(
  defineProps<{
    icon?: Component
  }>(),
  {
    icon: () => IconPriceTagFilled,
  },
)

const i18n = useI18n()
const experiments = useExperiments()
const marketplace = useMarketplace()

const hasTelcoCalculator = computed(() => {
  return (
    experiments['experiment.ppTelcoCalculator'] === 'withCalculator' &&
    marketplace.market.countryCode === MarketCountryCode.US
  )
})
</script>
